import { render, staticRenderFns } from "./Updata.vue?vue&type=template&id=6beeedf1&scoped=true&"
import script from "./Updata.vue?vue&type=script&lang=js&"
export * from "./Updata.vue?vue&type=script&lang=js&"
import style0 from "./Updata.vue?vue&type=style&index=0&id=6beeedf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beeedf1",
  null
  
)

export default component.exports